import { signIn, signOut } from 'aws-amplify/auth';

import { ALLOW_CHANGE_PASSWORD, AUTH_LOGIN, EVENT_MATCHES_EDIT_MODAL_HIDE, EVENT_MATCHES_EDIT_MODAL_SHOW } from '../constants/action-types';
import { deepCopy } from '../utils';
import { refreshFleet } from './typedActions';

//--------------------------------------------------------------
// Event Viewer Modal
//--------------------------------------------------------------

export const matchesEditorModalOpen = (event) => {
  const clonedEvent = deepCopy(event);
  return {
    type: EVENT_MATCHES_EDIT_MODAL_SHOW,
    event: clonedEvent,
  };
};

export const matchesEditorModalClose = () => {
  return {
    type: EVENT_MATCHES_EDIT_MODAL_HIDE,
    event: null,
  };
};

//--------------------------------------------------------------
// AUTH
//--------------------------------------------------------------

export const failedAuthLogin = () => {
  return {
    type: AUTH_LOGIN,
    isAuthenticated: false,
  };
};

export const allowChangePasswordFunc = () => {
  return {
    type: ALLOW_CHANGE_PASSWORD,
    allowChangePassword: true,
  };
};

export function authLogin(user, password) {
  window.debug && console.log('1');
  return function (dispatch, getState) {
    window.debug && console.log('2');
    signIn({
      username: user,
      password,
      options: {
        authFlowType: 'USER_PASSWORD_AUTH',
      },
    })
      .then((data) => dispatch(refreshFleet(true)))
      .catch((error) => dispatch(failedAuthLogin(true)));
  };
}

export function authLogout() {
  return function (dispatch, getState) {
    signOut().then((data) => {
      dispatch(failedAuthLogin(data));
      window.location.href = '/';
    });
  };
}
